import * as roomStringUtils from '../../../verticals/hotels-dweb/src/shared/utils/room-string-utils';

export default roomStringUtils;
